/* Justyol — COD express popup (PDP).
   Express click: adds the current product to the cart, then shows a mini
   checkout of the WHOLE cart (all items + subtotal/discount/shipping/total)
   and creates the order via window.JY_COD_ENDPOINT. Cart is cleared on
   success. */
(function () {
  'use strict';

  var root = document.querySelector('[data-jy-codx]');
  if (!root) return;

  var isAr = (document.documentElement.lang || '').indexOf('ar') === 0;
  var form = root.querySelector('[data-jy-codx-form]');
  var doneEl = root.querySelector('[data-jy-codx-done]');
  var errEl = root.querySelector('[data-jy-codx-err]');
  var citySel = root.querySelector('[data-jy-codx-city]');
  var submitBtn = root.querySelector('[data-jy-codx-submit]');
  var itemsEl = root.querySelector('[data-jy-codx-items]');
  var totalsEl = root.querySelector('[data-jy-codx-totals]');

  var cartItems = null; /* [{variantId, quantity}] */
  var discountCents = 0;
  var lastOrderSnapshot = null; /* rich cart snapshot for the /pages/merci page */
  var ordered = false;
  var addedKeys = {}; /* variant:qty already added — avoid double-add on reopen */
  var orderIdemKey = ''; /* stable across retries of the same order; cleared on success */
  function jyUuid() {
    try {
      if (crypto && crypto.randomUUID) return crypto.randomUUID();
    } catch (e) { /* noop */ }
    return 'k' + Date.now() + Math.random().toString(16).slice(2);
  }

  var AOV = window.JY_AOV || {};
  var FREE = (AOV.freeShip || 299) * 100;
  var FEE = (AOV.fee || 25) * 100;

  function fmtMoney(cents) {
    var n = Math.round((cents || 0) / 100);
    return n.toLocaleString(isAr ? 'ar-MA' : 'fr-FR') + ' ' + (isAr ? 'درهم' : 'Dhs');
  }

  /* ---- ad/analytics events — the express flow bypasses Shopify checkout ---- */
  var lastGrand = 0; /* cents */
  var trackedOpen = false;
  var purchaseEventId = ''; /* shared with the backend CAPI for dedup */
  /* first-order-from-the-app welcome discount (in-app webview = ?app=1) */
  var lastAfter = 0; /* cents — product total (post line-discount, pre-shipping) */
  var lastFee = 0; /* cents — shipping */
  var appOfferMad = 0; /* MAD off to reflect in the shown total (0 = none) */
  var appReplaces = false; /* app promo beat an existing cart discount → it replaces it */
  var appOfferKey = ''; /* phone+subtotal already checked, avoids re-hitting the API */
  var appOfferBusy = false;
  var appOfferDirty = false; /* a cart change landed while a check was in flight */
  var cartMutating = 0; /* in-flight /cart/change.js requests (stepper/remove) */
  function trackContents() {
    return (cartItems || []).map(function (it) {
      return { id: String(it.productId || it.variantId || ''), quantity: it.quantity || 1 };
    }).filter(function (c) { return c.id; });
  }

  /* server-side IC bridge: beacon the same eventID + browser ids to the
     worker, which mirrors this InitiateCheckout via the Conversions API —
     Meta dedupes on the shared id, lifting event coverage past 75%. */
  function beaconIcCapi(icEid, valueCents) {
    try {
      var ep = 'https://justyol-cod.justyol.workers.dev';
      try {
        if (window.JY_COD_ENDPOINT) ep = new URL(window.JY_COD_ENDPOINT).origin;
      } catch (e0) {}
      var pc = window.JY_FX && JY_FX.pixelContext ? JY_FX.pixelContext() : {};
      var body = JSON.stringify({
        e: 'ic_capi',
        eventId: icEid,
        fbp: pc.fbp || '',
        fbc: pc.fbc || '',
        url: pc.url || location.href,
        value: Math.round(valueCents) / 100,
      });
      if (!(navigator.sendBeacon && navigator.sendBeacon(ep + '/t', body))) {
        fetch(ep + '/t', { method: 'POST', body: body, keepalive: true }).catch(function () {});
      }
    } catch (e) {
      /* analytics only */
    }
  }

  function track(fbName, gaName, data) {
    var contents = trackContents();
    var ids = contents.map(function (c) { return c.id; });
    try {
      var plat = window.JY_IS_APP === true ? 'app' : 'web'; /* segment funnel by app vs web */
      if (window.fbq) fbq('track', fbName, { value: data.value, currency: 'MAD', num_items: data.num, content_type: 'product', content_ids: ids, contents: contents, jy_platform: plat }, data.eventId ? { eventID: data.eventId } : undefined);
    } catch (e) { /* noop */ }
    try {
      var gaItems = contents.map(function (c) { return { item_id: c.id, quantity: c.quantity }; });
      var p = { value: data.value, currency: 'MAD', items: gaItems };
      if (data.id) p.transaction_id = data.id;
      p.jy_platform = window.JY_IS_APP === true ? 'app' : 'web';
      if (window.gtag) gtag('event', gaName, p);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: gaName }, p));
    } catch (e) { /* noop */ }
    try {
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('jyEvent', { name: fbName, value: data.value || 0, currency: 'MAD', contentIds: ids });
      }
    } catch (e) { /* noop */ }
    try {
      if (window.ttq) ttq.track(fbName === 'Purchase' ? 'CompletePayment' : fbName, { value: data.value, currency: 'MAD', content_id: ids[0], content_type: 'product', contents: contents, jy_platform: window.JY_IS_APP === true ? 'app' : 'web' });
    } catch (e) { /* noop */ }
  }

  /* ---- populate cities ---- */
  if (citySel && window.JY_CITIES && citySel.options.length <= 1) {
    var frag = document.createDocumentFragment();
    window.JY_CITIES.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;
      o.textContent = c;
      frag.appendChild(o);
    });
    citySel.appendChild(frag);
  }

  /* ---- render the whole-cart summary ---- */
  function renderCart(cart) {
    cartItems = cart.items.map(function (it) {
      return { variantId: it.variant_id, productId: it.product_id, quantity: it.quantity };
    });
    discountCents = cart.total_discount || 0;
    /* the cart just changed — drop any promo shown for the OLD basket so
       paintTotal never renders a stale discount; checkAppOffer re-derives it
       for the new basket (forced by clearing appOfferKey). */
    appOfferMad = 0;
    appReplaces = false;
    appOfferKey = '';

    if (itemsEl) {
      itemsEl.innerHTML = cart.items
        .map(function (it) {
          return (
            '<div class="jy-codx__item" data-key="' + escapeHtml(it.key) + '">' +
            (it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" width="44" height="44" loading="lazy">' : '') +
            '<span class="jy-codx__item-t">' +
            '<span class="jy-codx__item-title">' + escapeHtml(it.product_title) + '</span>' +
            '<span class="jy-codx__item-p">' + fmtMoney(it.original_line_price || it.final_line_price) + '</span>' +
            '</span>' +
            /* per-line quantity stepper (like the cart): − reduces by one, + adds
               one, so a customer can drop from 3 pieces to 2 instead of the ✕
               nuking the whole line */
            '<span class="jy-codx__qty" role="group">' +
            '<button type="button" class="jy-codx__qty-b" data-jy-codx-dec aria-label="' +
            (isAr ? 'إنقاص' : 'Diminuer') + '">−</button>' +
            '<span class="jy-codx__qty-n" data-jy-codx-qn>' + it.quantity + '</span>' +
            '<button type="button" class="jy-codx__qty-b" data-jy-codx-inc aria-label="' +
            (isAr ? 'زيادة' : 'Augmenter') + '">+</button>' +
            '</span>' +
            '<button type="button" class="jy-codx__item-rm" data-jy-codx-rm aria-label="' +
            (isAr ? 'حذف' : 'Supprimer') +
            '">✕</button>' +
            '</div>'
          );
        })
        .join('');
    }

    if (totalsEl) {
      var sub = cart.original_total_price || cart.total_price;
      var after = cart.total_price;
      /* free when the order clears the threshold OR the product being bought
         ships free (winners collection / custom.free_shipping — set on the PDP) */
      var freeOk = after >= FREE || AOV.freeShipItem === true;
      var fee = freeOk ? 0 : FEE;
      set('[data-jy-codx-sub]', fmtMoney(sub));
      var discRow = totalsEl.querySelector('[data-jy-codx-discrow]');
      if (discRow) {
        discRow.hidden = discountCents <= 0;
        if (discountCents > 0) set('[data-jy-codx-disc]', '−' + fmtMoney(discountCents));
      }
      set('[data-jy-codx-ship]', freeOk ? (isAr ? 'مجاني ✓' : 'Offerte ✓') : fmtMoney(fee));
      lastAfter = after;
      lastFee = fee;
      totalsEl.hidden = false;
      lastOrderSnapshot = {
        items: cart.items.map(function (it) {
          /* original (pre cart-discount) line price so the items reconcile with
             the authoritative subtotal shown on the confirmation */
          return {
            title: it.product_title,
            qty: it.quantity,
            priceText: fmtMoney(it.original_line_price || it.final_line_price),
            image: it.image,
          };
        }),
        subText: fmtMoney(sub),
        discText: discountCents > 0 ? '−' + fmtMoney(discountCents) : '',
        shipText: freeOk ? (isAr ? 'مجاني ✓' : 'Offerte ✓') : fmtMoney(fee),
        totalText: fmtMoney(after + fee),
      };
      paintTotal(); /* sets total + lastGrand, accounting for the app first-order offer */
      if (!trackedOpen) {
        trackedOpen = true;
        /* eventID so Meta can dedupe this IC against any future server copy */
        var icEid = 'jy-ic-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
        track('InitiateCheckout', 'begin_checkout', { value: lastGrand / 100, num: cart.items.length, eventId: icEid });
        beaconIcCapi(icEid, lastGrand);
      }
      checkAppOffer(); /* in-app: reveal/refresh the offer if a phone is already present */
    }
  }
  function set(sel, txt) {
    var el = root.querySelector(sel);
    if (el) el.textContent = txt;
  }

  /* paint the grand total, subtracting the app first-order offer (if any). The
     worker applies the same discount authoritatively at order creation, so the
     shown total matches what the customer pays. */
  function paintTotal() {
    if (!totalsEl) return;
    var offCents = appOfferMad > 0 ? Math.round(appOfferMad * 100) : 0;
    /* when the app promo beat an existing cart discount it REPLACES it: add
       that discount back to the base and hide its row, so the total reads
       goods − appPromo (matching the worker), never goods − both. */
    var addBack = appReplaces ? discountCents : 0;
    var base = lastAfter + addBack;
    offCents = Math.min(offCents, base + lastFee);
    var discRow = totalsEl.querySelector('[data-jy-codx-discrow]');
    if (discRow && appReplaces) discRow.hidden = true;
    var appRow = totalsEl.querySelector('[data-jy-codx-approw]');
    if (appRow) {
      appRow.hidden = offCents <= 0;
      if (offCents > 0) set('[data-jy-codx-app]', '−' + fmtMoney(offCents));
    }
    var grand = base + lastFee - offCents;
    set('[data-jy-codx-total]', fmtMoney(grand));
    lastGrand = grand;
    if (lastOrderSnapshot) lastOrderSnapshot.totalText = fmtMoney(grand);
    /* spend & save: progress to the next discount tier. Feed the pre-discount
       goods subtotal (Shopify's threshold basis) so "remaining to next tier" is
       exact — same basis as the app-offer check below. */
    if (window.JY_TIER && window.JY_TIER.render) {
      window.JY_TIER.render(((lastAfter || 0) + discountCents) / 100);
    }
  }

  /* in-app only (?app=1): ask the backend whether this phone gets the first-order
     welcome discount, then show it (or an "add X more" nudge). Display only —
     the real discount is enforced server-side at order creation. */
  function checkAppOffer() {
    if (window.JY_IS_APP !== true || !window.JY_COD_ENDPOINT || !totalsEl) return;
    // in-app promo: any app order clears it (no phone / first-order check).
    // send GOODS (pre cart-discount) so the 250 threshold matches the worker,
    // which computes from the pre-discount subtotal. exact (unrounded) so the
    // boundary lines up at 250.
    var goodsCents = (lastAfter || 0) + discountCents;
    var subMad = goodsCents / 100;
    var key = 's:' + subMad;
    if (appOfferKey === key) return;
    /* a check is already running — remember to re-run for the latest basket
       instead of dropping this call (rapid stepper taps must not strand a
       stale discount on screen) */
    if (appOfferBusy) { appOfferDirty = true; return; }
    appOfferBusy = true;
    fetch(String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') + '/app/first-order-offer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subtotal: subMad }),
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        appOfferKey = key;
        var more = root.querySelector('[data-jy-codx-appmore]');
        if (j && j.ok && j.eligible) {
          var cand = j.qualifies ? j.discount || 0 : 0;
          // exclusive — bigger wins. The promo only shows if it beats any
          // existing cart discount; then it REPLACES it (appReplaces).
          if (cand > 0 && Math.round(cand * 100) > discountCents) {
            appOfferMad = cand;
            appReplaces = discountCents > 0;
          } else {
            appOfferMad = 0;
            appReplaces = false;
          }
          if (more) {
            // below the entry tier → nudge to unlock it; already earning a tier
            // but a bigger one is in reach → nudge to the next threshold (AOV)
            var nudgeAmt = j.qualifies ? j.remainingToNext : j.remaining;
            var nudgeOff = j.qualifies ? j.nextOffer : j.offer;
            if (nudgeAmt && nudgeOff) {
              more.hidden = false;
              more.textContent = isAr
                ? 'ضِف ' + Math.ceil(nudgeAmt) + ' درهم واحصل على خصم ' + nudgeOff + ' درهم على طلبك من التطبيق 🎁'
                : 'Ajoutez ' + Math.ceil(nudgeAmt) + ' Dhs et obtenez ' + nudgeOff + ' Dhs de remise sur votre commande app 🎁';
            } else {
              more.hidden = true;
            }
          }
        } else {
          appOfferMad = 0;
          appReplaces = false;
          if (more) more.hidden = true;
        }
        paintTotal();
      })
      .catch(function () {
        /* network blip — clear any stale promo rather than leave it painted */
        appOfferMad = 0;
        appReplaces = false;
        appOfferKey = '';
        paintTotal();
      })
      .finally(function () {
        appOfferBusy = false;
        if (appOfferDirty) { appOfferDirty = false; checkAppOffer(); }
      });
  }

  /* ---- returning customer: prefill saved details ---- */
  var CUST_KEY = 'jy_cod_customer';
  function prefill() {
    try {
      var saved = JSON.parse(localStorage.getItem(CUST_KEY) || 'null');
      if (!saved) return;
      ['name', 'phone', 'address'].forEach(function (k) {
        var inp = form.querySelector('[name="' + k + '"]');
        if (inp && !inp.value) inp.value = saved[k] || '';
      });
      if (citySel && !citySel.value && saved.city) citySel.value = saved.city;
    } catch (e) {
      /* noop */
    }
  }
  function saveCustomer(c) {
    try {
      localStorage.setItem(CUST_KEY, JSON.stringify(c));
    } catch (e) {
      /* noop */
    }
  }
  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }
  /* placeholder rows shown while add.js -> cart.js resolve (perceived speed) */
  function skeletonRows() {
    var bundle = window.JY_BUNDLE && window.JY_BUNDLE.pieces && window.JY_BUNDLE.pieces.length > 1;
    var n = bundle ? Math.min(window.JY_BUNDLE.pieces.length, 4) : 2;
    var row =
      '<div class="jy-codx__item jy-codx__item--skel" aria-hidden="true">' +
      '<span class="jy-codx__skel jy-codx__skel--img"></span>' +
      '<span class="jy-codx__item-t">' +
      '<span class="jy-codx__skel jy-codx__skel--line"></span>' +
      '<span class="jy-codx__skel jy-codx__skel--short"></span>' +
      '</span>' +
      '<span class="jy-codx__skel jy-codx__skel--price"></span>' +
      '</div>';
    var out = '';
    for (var i = 0; i < n; i++) out += row;
    return out;
  }

  /* ---- open / close ---- */
  function close() {
    root.classList.remove('is-on');
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      root.hidden = true;
    }, 280);
    if (ordered) window.location.reload(); /* cart was cleared — refresh badges */
  }

  /* keep the header/bottom-nav cart badges in sync with the popup's silent
     cart mutations (add on open, remove from inside) */
  function publishCart(cart) {
    try {
      if (cart && window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      }
    } catch (e) {
      /* noop */
    }
  }

  function openExpress() {
    ordered = false;
    showErr(false);
    form.hidden = false;
    doneEl.hidden = true;
    if (itemsEl) itemsEl.innerHTML = skeletonRows();
    if (totalsEl) totalsEl.hidden = true;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    void root.offsetWidth;
    root.classList.add('is-on');
    prefill();

    /* add the current PDP selection to the cart, then load the full cart.
       Tracked per VARIANT (not variant:qty): reopening with the same variant
       never double-adds, and a changed qty updates the existing line instead
       of stacking a second one. */
    var pdpForm = document.querySelector('form[id^="JyProductForm"]');
    var idInput = pdpForm && pdpForm.querySelector('[name="id"]');
    var qtyInput = pdpForm && pdpForm.querySelector('[name="quantity"]');

    /* multi-piece bundle (SHEIN/Temu-style mix): add each chosen variant as its
       own line instead of qty×N of one variant. */
    var bundle = window.JY_BUNDLE && window.JY_BUNDLE.pieces && window.JY_BUNDLE.pieces.length > 1
      ? window.JY_BUNDLE
      : null;

    var addPromise;
    if (bundle) {
      var tierProp = 't' + bundle.tier;
      var toAdd = bundle.pieces.filter(function (p) {
        return addedKeys['b' + p.id] === undefined;
      });
      toAdd.forEach(function (p) {
        addedKeys['b' + p.id] = 1;
      });
      addPromise = toAdd.length
        ? fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: toAdd.map(function (p) {
                return { id: p.id, quantity: p.quantity, properties: { _jy_tier: tierProp } };
              }),
            }),
          })
        : Promise.resolve();
    } else {
      var vid = idInput ? parseInt(idInput.value, 10) : 0;
      var wantQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var mutation = null;
      if (vid) {
        if (addedKeys[vid] === undefined) {
          mutation = { url: '/cart/add.js', body: { id: vid, quantity: wantQty } };
        } else if (addedKeys[vid] !== wantQty) {
          /* qty changed between opens → set the line's absolute quantity */
          mutation = { url: '/cart/change.js', body: { id: String(vid), quantity: wantQty } };
        }
        addedKeys[vid] = wantQty;
      }
      addPromise = mutation
        ? fetch(mutation.url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(mutation.body),
          })
        : Promise.resolve();
    }

    addPromise
      .then(function (addRes) {
        /* validate stock at the ADD step, not after the form: Shopify rejects
           /cart/add.js (422) for a tracked + deny variant that's out of stock,
           so the shopper learns right away instead of filling everything first. */
        if (addRes && !addRes.ok) {
          throw new Error('add_unavailable');
        }
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        publishCart(cart);
        if (!cart.items || !cart.items.length) {
          showErr(isAr ? 'تعذّر تجهيز الطلب، حاول مجددًا.' : 'Impossible de préparer la commande, réessayez.');
          return;
        }
        renderCart(cart);
      })
      .catch(function (err) {
        if (err && String(err.message) === 'add_unavailable') {
          showErr(
            isAr
              ? 'نفد مخزون هذا المنتج أو غير متوفر بالكمية المطلوبة 😔'
              : 'Ce produit est en rupture ou indisponible dans cette quantité 😔'
          );
          return;
        }
        showErr(isAr ? 'تعذّر تجهيز الطلب، حاول مجددًا.' : 'Impossible de préparer la commande, réessayez.');
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var openBtn = e.target.closest('[data-jy-cta="express"]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        openExpress();
        return;
      }
      if (e.target.closest('[data-jy-codx-close]')) close();
    },
    true
  );
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  /* ---- adjust / remove a line item from inside the popup ----
     One handler for the −, +, and ✕ controls. change.js keyed by the LINE key
     only ever touches that one line, so dropping a piece never nukes the rest
     of the basket. quantity 0 removes the line entirely. */
  function changeLine(key, quantity, row) {
    row.classList.add('is-busy');
    cartMutating++;
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (quantity === 0) {
          /* forget the removed variant so reopening the popup can add it again
             (leaving it in addedKeys used to deadlock the express flow) */
          var rmVid = parseInt(String(key).split(':')[0], 10);
          if (rmVid) delete addedKeys[rmVid];
        }
        publishCart(cart);
        if (!cart.items || !cart.items.length) {
          cartItems = [];
          if (itemsEl) {
            itemsEl.innerHTML =
              '<div class="jy-codx__loading">' + (isAr ? 'سلتك فارغة' : 'Votre panier est vide') + '</div>';
          }
          if (totalsEl) totalsEl.hidden = true;
          return;
        }
        renderCart(cart);
      })
      .catch(function () {
        row.classList.remove('is-busy');
      })
      .finally(function () {
        if (cartMutating > 0) cartMutating--;
      });
  }
  root.addEventListener('click', function (e) {
    var ctl = e.target.closest('[data-jy-codx-rm],[data-jy-codx-inc],[data-jy-codx-dec]');
    if (!ctl) return;
    var row = ctl.closest('.jy-codx__item');
    var key = row && row.getAttribute('data-key');
    if (!key) return;
    if (ctl.hasAttribute('data-jy-codx-rm')) {
      changeLine(key, 0, row);
      return;
    }
    var qn = row.querySelector('[data-jy-codx-qn]');
    var cur = qn ? parseInt(qn.textContent, 10) || 1 : 1;
    if (ctl.hasAttribute('data-jy-codx-inc')) {
      changeLine(key, cur + 1, row);
    } else {
      /* − at qty 1 removes the line (matches the cart's stepper behaviour) */
      changeLine(key, Math.max(0, cur - 1), row);
    }
  });

  /* ---- abandoned-form capture (same contract as the checkout page) ---- */
  var abandonLast = 0;
  function captureAbandoned() {
    if (!window.JY_COD_ENDPOINT || ordered) return;
    var phoneEl = form.querySelector('[name="phone"]');
    var phone = phoneEl ? phoneEl.value.trim() : '';
    if (phone.replace(/[^\d]/g, '').length < 9) return;
    var now = Date.now();
    if (now - abandonLast < 60000) return;
    abandonLast = now;
    var nameEl = form.querySelector('[name="name"]');
    fetch(String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') + '/abandoned', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone: phone,
        name: nameEl ? nameEl.value.trim() : '',
        city: citySel ? citySel.value : '',
        items: cartItems || [],
        total: lastGrand,
        src: 'express',
        website: '',
      }),
    }).catch(function () {
      /* best-effort */
    });
  }
  form.addEventListener('change', function () {
    captureAbandoned();
    checkAppOffer();
  });
  (function () {
    var pEl = form.querySelector('[name="phone"]');
    if (pEl) {
      pEl.addEventListener('blur', function () {
        captureAbandoned();
        checkAppOffer();
      });
    }
  })();

  /* ---- top-cities quick chips: one tap fills the 500+ option select ----
     Chip labels ("Casablanca", "Fès") don't always match the option casing/accents
     in JY_CITIES ("CASABLANCA", "Fes"), so match normalised (upper + no diacritics)
     and, if the city isn't in the list, add it — otherwise the tap set no value and
     validation kept saying "Choisissez votre ville". */
  function jyNormCity(s) {
    return (s || '').toString().trim().toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function jySelectCity(name) {
    if (!citySel) return;
    var target = jyNormCity(name);
    var matched = '';
    for (var i = 0; i < citySel.options.length; i++) {
      if (citySel.options[i].value && jyNormCity(citySel.options[i].value) === target) {
        matched = citySel.options[i].value;
        break;
      }
    }
    if (!matched) {
      var o = document.createElement('option');
      o.value = name;
      o.textContent = name;
      citySel.appendChild(o);
      matched = name;
    }
    citySel.value = matched;
    jySyncCityChips();
  }
  function jySyncCityChips() {
    if (!citySel) return;
    var cur = jyNormCity(citySel.value);
    root.querySelectorAll('[data-jy-city-chip]').forEach(function (c) {
      c.classList.toggle('is-on', jyNormCity(c.getAttribute('data-jy-city-chip')) === cur && cur !== '');
    });
  }
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-jy-city-chip]');
    if (!chip || !citySel) return;
    jySelectCity(chip.getAttribute('data-jy-city-chip'));
  });
  if (citySel) {
    citySel.addEventListener('change', jySyncCityChips);
  }

  /* ---- validation ---- */
  function showErr(msg) {
    if (!errEl) return;
    errEl.hidden = !msg;
    if (msg) errEl.textContent = msg;
  }
  function validPhone(v) {
    var digits = (v || '').replace(/[^\d]/g, '');
    return digits.length >= 9 && digits.length <= 15;
  }
  function setLoading(on) {
    if (!submitBtn) return;
    submitBtn.disabled = on;
    var spin = submitBtn.querySelector('.jy-codx__spin');
    var lbl = submitBtn.querySelector('.jy-codx__submit-lbl');
    if (spin) spin.hidden = !on;
    if (lbl) lbl.style.opacity = on ? '0.5' : '1';
  }

  /* ---- submit ---- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(form);
    var name = (fd.get('name') || '').trim();
    var phone = (fd.get('phone') || '').trim();
    var city = (fd.get('city') || '').trim();
    var address = (fd.get('address') || '').trim();

    if (name.length < 3) return showErr(isAr ? 'من فضلك اكتب اسمك.' : 'Veuillez saisir votre nom.');
    if (!validPhone(phone)) return showErr(isAr ? 'رقم هاتف غير صحيح.' : 'Numéro de téléphone invalide.');
    if (!city) return showErr(isAr ? 'اختر مدينتك.' : 'Choisissez votre ville.');
    if (address.length < 5) return showErr(isAr ? 'اكتب عنوانك بالتفصيل.' : 'Saisissez votre adresse.');
    if (!cartItems || !cartItems.length) return showErr(isAr ? 'سلتك فارغة.' : 'Votre panier est vide.');
    /* a stepper/remove change is still saving — don't submit stale quantities */
    if (cartMutating > 0) {
      return showErr(isAr ? 'جارٍ تحديث السلة، لحظة…' : 'Mise à jour du panier, un instant…');
    }
    showErr(false);

    var endpoint = window.JY_COD_ENDPOINT;
    if (!endpoint) {
      return showErr(isAr ? 'خدمة الطلب السريع غير مفعّلة بعد.' : "Le service de commande rapide n'est pas encore activé.");
    }

    setLoading(true);
    var pctx = window.JY_FX && JY_FX.pixelContext ? JY_FX.pixelContext() : {};
    purchaseEventId = pctx.eventId;
    /* same key across retries of this order so a lost response can't double-order */
    if (!orderIdemKey) orderIdemKey = jyUuid();
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        idempotencyKey: orderIdemKey,
        items: cartItems,
        discount: discountCents,
        /* client's free-ship claim (from the Shopify-rendered metafield) — the
           Worker verifies server-side and only falls back to this if it can't */
        freeShip: !!(window.JY_AOV && window.JY_AOV.freeShipItem === true),
        name: name,
        phone: phone,
        city: city,
        address: address,
        website: (fd.get('website') || '').trim(),
        payMethod: 'cod',
        app: window.JY_IS_APP === true,
        locale: isAr ? 'ar' : 'fr',
        pixel: pctx,
      }),
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (j) {
            return { ok: r.ok, body: j };
          });
      })
      .then(function (res) {
        if (!res.ok || !res.body || res.body.ok === false) {
          var oErr = new Error((res.body && res.body.error) || 'error');
          if (res.body) {
            oErr.available = res.body.available;
            oErr.item = res.body.item;
          }
          throw oErr;
        }
        var ref = root.querySelector('[data-jy-codx-ref]');
        if (ref && res.body.orderName) {
          ref.textContent = (isAr ? 'رقم الطلب: ' : 'N° commande : ') + res.body.orderName;
        }
        ordered = true;
        orderIdemKey = ''; /* next order gets a fresh idempotency key */
        var waHelp = root.querySelector('[data-jy-codx-wahelp]');
        if (waHelp && window.JY_WA && res.body.orderName) {
          var helpTxt = isAr
            ? 'السلام، عندي سؤال عن طلبي ' + res.body.orderName
            : "Bonjour, j'ai une question sur ma commande " + res.body.orderName;
          waHelp.href =
            'https://wa.me/' + String(window.JY_WA).replace(/[^\d]/g, '') + '?text=' + encodeURIComponent(helpTxt);
          waHelp.hidden = false;
        }
        saveCustomer({ name: name, phone: phone, city: city, address: address });
        try {
          var snap = lastOrderSnapshot || {};
          /* prefer the worker's authoritative breakdown (what was actually
             charged) over the client cart snapshot — under the bigger-wins promo
             the cart's discount/total can differ from the order. */
          var b = res.body || {};
          var subText = typeof b.subtotal === 'number' ? fmtMoney(Math.round(b.subtotal * 100)) : snap.subText || '';
          var discText =
            typeof b.discount === 'number'
              ? b.discount > 0
                ? '−' + fmtMoney(Math.round(b.discount * 100))
                : ''
              : snap.discText || '';
          var shipText =
            typeof b.shipping === 'number'
              ? b.shipping > 0
                ? fmtMoney(Math.round(b.shipping * 100))
                : isAr
                ? 'مجاني ✓'
                : 'Offerte ✓'
              : snap.shipText || '';
          var totalText = typeof b.total === 'number' ? fmtMoney(Math.round(b.total * 100)) : snap.totalText || '';
          sessionStorage.setItem(
            'jy_last_order',
            JSON.stringify({
              ref: res.body.orderName || '',
              items: snap.items || [],
              subText: subText,
              discText: discText,
              shipText: shipText,
              totalText: totalText,
              name: name,
              phone: phone,
              city: city,
              address: address,
              pay: 'cod',
              ts: Date.now(),
              /* Purchase pixel data — fired on /pages/merci (more reliable than
                 firing right before this redirect). eventID matches the server
                 CAPI event_id sent to the Worker, so Meta/TikTok dedupe them. */
              fx: {
                items: cartItems || [],
                /* fire the authoritative charged total the Worker returned (matches
                   the Shopify order + the server CAPI value exactly) — falls back to
                   the client estimate only if the Worker didn't send one */
                value: typeof b.total === 'number' ? b.total : lastGrand / 100,
                num: (cartItems || []).length,
                eventID: purchaseEventId,
                id: res.body.orderName || '',
                /* Enhanced Conversions identifiers (Google Ads) — hashed by gtag */
                phone: phone,
                firstName: (name || '').trim().split(/\s+/)[0] || '',
                lastName: (name || '').trim().split(/\s+/).slice(1).join(' ') || '',
                city: city,
                street: address,
              },
            })
          );
        } catch (e) {
          /* noop */
        }
        /* clear the cart (keepalive so it survives the redirect) then go to the
           dedicated confirmation page instead of the in-modal done state */
        fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', keepalive: true }).catch(function () {});
        form.hidden = true;
        doneEl.hidden = false;
        var mroot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        if (mroot.charAt(mroot.length - 1) !== '/') mroot += '/';
        window.location.href = mroot + 'pages/merci';
      })
      .catch(function (err) {
        var code = String(err && err.message);
        var msg;
        if (code === 'out_of_stock') {
          msg = isAr ? 'نفد مخزون هذا المنتج 😔' : 'Ce produit est en rupture de stock 😔';
        } else if (code === 'insufficient_stock') {
          var n = err && typeof err.available === 'number' ? err.available : 0;
          msg = isAr
            ? 'بقي فقط ' + n + ' قطعة من هذا المنتج — قلّل الكمية.'
            : 'Il ne reste que ' + n + ' article(s) — réduisez la quantité.';
        } else if (code === 'rate_limited') {
          msg = isAr ? 'محاولات كثيرة — انتظر دقيقة وحاول مجددًا.' : 'Trop de tentatives — patientez une minute.';
        } else {
          msg = isAr ? 'تعذّر إرسال الطلب، حاول مجددًا.' : "Échec de l'envoi, réessayez.";
        }
        showErr(msg);
      })
      .finally(function () {
        setLoading(false);
      });
  });
})();
